import React from "react";

import moment from "moment";
import { connect } from "react-redux";
import history from "../../auth/history";
import { CSVLink } from "react-csv";

class ManageConsumerSubComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            phoneNo: this.props.phone,
            consumerList: []
        }
    }

    componentDidMount() {
        var consumerList1 = [];
        if (this.props.bulkUpload.consumerList != null &&
            this.props.bulkUpload.consumerList != undefined &&
            this.props.bulkUpload.consumerList.length > 0) {
            var consumerList = this.props.bulkUpload.consumerList;
            consumerList.map(consumer => {
                if (consumer.optional != null) {
                    const map = new Map(Object.entries(consumer.optional));
                    var val = "";
                    var mapKeys = [...map.keys()];
                    // alert(mapKeys);

                    mapKeys.map(key => {
                        val = val + key + "=" + map.get(key) + ";"
                    })
                    consumer.optional = val;
                    // alert(JSON.stringify(consumer));
                    consumerList1.push(consumer);
                } else {
                    consumerList1.push(consumer);
                }

            })

        }

        this.setState({
            consumerList: consumerList1
        })

    }
    componentWillUnmount() {
    }




    render() {

        return (
            <div class="filelist">
                <div class="row">
                    <div class="col-8 col-md-4">
                        <div class="filetxt">
                            <p>Uploaded by  {this.props.bulkUpload.agentId}</p>
                            <h4>File: {this.props.bulkUpload.fileName}</h4>
                            <p class="date">{moment(this.props.bulkUpload.createdOn)
                                .format('DD-MM-YYYY HH:mm:ss')}</p>
                        </div>
                    </div>

                    <div class="col-4 col-md">
                        <div class="filetxt text-end text-md-start">
                            <p>Consumers</p>
                            <h5>{(this.props.bulkUpload.consumerList != null &&
                                this.props.bulkUpload.consumerList != undefined) ?
                                this.props.bulkUpload.consumerList.length :
                                0}</h5>
                        </div>
                    </div>

                    <div class="col-4 col-md">
                        <div class="filetxt">
                            <p>Duplicate</p>
                            <h5 class="dup">{this.props.bulkUpload.duplicate}</h5>
                        </div>
                    </div>

                    <div class="col-3 col-md">
                        <div class="filetxt">
                            <p>Failed</p>
                            <h5 class="fail">{this.props.bulkUpload.rejected}</h5>
                        </div>
                    </div>
                    <div class="col-3 col-md">
                        <div class="filetxt">
                            <p>Success</p>
                            <h5 class="success">{this.props.bulkUpload.success}</h5>
                        </div>
                    </div>

                    {(this.state.consumerList != null &&
                        this.state.consumerList != undefined &&
                        this.state.consumerList.length > 0) ?
                        <div class="col-5 col-md">
                            {(this.props.bulkUpload.status != null &&
                                this.props.bulkUpload.status != undefined &&
                                this.props.bulkUpload.status != "") ?
                                this.props.bulkUpload.status : 'NA'}
                            <div class="filetxt">
                                <CSVLink
                                    class="downbtn"
                                    data={this.state.consumerList}
                                    asyncOnClick={true}
                                    // onClick={this.resetExportDate}
                                    filename={this.props.bulkUpload.fileName + ".csv"}
                                >
                                    Download
                                </CSVLink>
                            </div>
                        </div> :
                        <div class="col-5 col-md">
                            {(this.props.bulkUpload.status != null &&
                                this.props.bulkUpload.status != undefined &&
                                this.props.bulkUpload.status != "") ?
                                this.props.bulkUpload.status : 'NA'}
                            <div class="filetxt">
                                <button type="button" class="downbtn" disabled
                                ></button>
                            </div>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (
    { errorMessageReduce: { errorMessage, loginErrorMessage, otpErrorMessage },
        miscReduce: { otpRefNo, phone } }
) => ({
    errorMessage, loginErrorMessage, otpErrorMessage, otpRefNo, phone
});

export default connect(mapStateToProps, null)(ManageConsumerSubComponent);
